<div class="container-fluid">
  <div class="grid_container">
    <div class="grid"></div>
    <div class="grid">
      @if (!codeFormActive) {
        <div class="container-login">
          <form [formGroup]="mailForm">
            <img src="./assets/img/logo_mascot_circle.png" alt="Logo Etoy Republic" />
            <h1>Login</h1>
            <p>Enter your email and we'll send you a login code</p>
            <div class="form-group">
              <input type="email" class="form-control" name="" id="" aria-describedby="emailHelpId" placeholder="Email" formControlName="email" />
            </div>
            <button type="button" class="btn__default btn__block" (click)="getCodeLogin()">Continuar</button>
          </form>
        </div>
      }
      @if (codeFormActive && !login) {
        <div class="container-login">
          <form [formGroup]="codeForm">
            <img src="./assets/img/logo_mascot_circle.png" alt="Logo Etoy Republic" />
            <h1>Ingresa el codigo</h1>
            <p>Sent to {{ mailForm.value.email }}</p>
            <div class="form-group">
              <input type="email" class="form-control" name="" id="" aria-describedby="emailHelpId" placeholder="Código de 6 dígitos" formControlName="code" />
            </div>
            <button type="button" class="btn__default btn__block" (click)="validateLogin()">Continuar</button>
          </form>
        </div>
      }
      @if (login) {
        <div class="container-login text-center">
          <img src="./assets/img/logo_mascot_circle.png" alt="Logo Etoy Republic" />
          <p>Tu session a sido exitosa</p>
          <p>Seras redireccionado en:</p>
          <p>{{ timer }}</p>
        </div>
      }
    </div>
    <div class="grid"></div>
  </div>
</div>
